import React from 'react';
import {
  Image,
  Text,
  Heading,
  SimpleGrid,
  Container
} from '@chakra-ui/react';
import HomeLayout from '../../components/layouts/homelayout';
import Seo from '../../components/sections/seo';
import PageHeader from '../../components/sections/pageheader';
import TextWithRightMedia from '../../components/sections/textwithrightmedia';
import TextWithLeftMedia from '../../components/sections/textwithleftmedia';

import ReactPlayer from 'react-player/youtube';

import VolunteerProjectsImg from '../../components/ui/corporateresponsibility/empoweringpeople/Backyard-Collective-1200x942.jpeg'
import SupplyChainImg from '../../components/ui/corporateresponsibility/empoweringpeople/Image-14-opt.jpeg'
import LocalCommunitiesImg from '../../components/ui/corporateresponsibility/empoweringpeople/OSU-collegiate-image-1200x800.jpeg'
import OutdoorParticipationImg from '../../components/ui/corporateresponsibility/empoweringpeople/S20_DRY_HI_MG_5365-600x406.jpeg'
import InspiringPeopleImg from '../../components//ui/corporateresponsibility/empoweringpeople/inspiring-employees.jpeg'
import HeroWithTopMedia from '../../components/sections/herowithtopmedia';

import Outside from '../../components/ui/corporateresponsibility/sustainingplaces/Outside.png';

export default function EmpoweringPeopleTab() {
  return (
    <HomeLayout>
      <Seo
        title="Corporate Responsibility - Empowering People"
        description="Empowering people in our supply chain, inspiring employees, and supporting outdoor particpation, access, and stewardship."
        //links={[{"rel": "canonical", "href": "https://www.columbiasportswearcompany.com/careers"}]}
      />
      <PageHeader 
            heading='Empowering People'
            bkgImg={Outside}
        />
      <Container maxW="6xl">

        <SimpleGrid align={'center'} columns={3} gap={10} py={4}>
          <HeroWithTopMedia
            title={<Text>EMPOWERING PEOPLE IN OUR SUPPLY CHAIN</Text>}
            subTitle="Empowering employees in our supply chain by supporting vendors' commitments to worker well-being programs, community programs, and advanced worker communication channels."
            media={
              <Image width="100%" src={SupplyChainImg} />
            }
          />
          <HeroWithTopMedia
            title="INSPIRING EMPLOYEES AND HAVING A POSITIVE IMPACT ON LOCAL COMMUNITIES"
            subTitle="Supporting local communities by providing opportunities that enable employees and business partners to give back to their communities through paid volunteer time and donation match program."
            media={
              <Image
                src={InspiringPeopleImg}
              />
            }
          />
          <HeroWithTopMedia
            title="SUPPORTING OUTDOOR PARTICIPATION, ACCESS AND STEWARDSHIP"
            subTitle="Investing in outdoor education, protection and restoration to inspire the next generation and activating a healthy community of outdoor consumers to protect the spaces we love."
            media={<Image src={OutdoorParticipationImg} />}
          />
        </SimpleGrid>
        <Heading as={'h2'}>
          Featured Initiatives
        </Heading>

        <TextWithRightMedia
          title={<h3>Collegiate Outdoor Recrecation Program</h3>}
          content={<p>Columbia Sportswear Company’s Collegiate Outdoor Recreation Program supports outdoor participation among university students by providing gear and equipment to selected schools. This gear includes tents, sleeping bags, packs along with critical pieces of individual gear like waterproof boots, rain shells and insulating layers. These donations allow students new to the outdoors to have confidence that the weather doesn’t have to keep them inside. We provide the product to keep them warm, dry and protected so that they have an incredible outdoor experience."</p>}   
                
          media={<Image src={LocalCommunitiesImg} />}
        />
        <TextWithLeftMedia
          title={<h3>Thanks to HER</h3>}
          content={<p>Women represent around 75% of Columbia Sportswear Company's global supply chain workforce. We are proud to help support and empower them through HERproject workplace training and enrichment programs. Since starting the program in 2008, we have positively impacted the lives of over 37,000 workers in seven countries through the HERhealth, HERfinance and HERrespect programs.</p>}
          cta_url={"https://www.columbia.com/her_project_pluscolsportswear.html"}
          cta_text={"Learn More"}
          media={
            <ReactPlayer
              align-items="center"
              url="https://www.youtube.com/embed/g3XXMqhcEk8?autoplay=0&rel=0&enablejsapi=1&wmode=opaque"
            />
          }
        />
        <TextWithRightMedia
          title={<h3>Global Employee Volunteer Projects</h3>}
          content={<p>Every employee of Columbia Sportswear Company is awarded paid volunteer hours per year for volunteer activities. Employees can choose the organization(s) they want to support individually, as well as participate in annual volunteer days organized by each office around the world.</p>}
          media={<Image src={VolunteerProjectsImg} />}
        />
      </Container>
      </HomeLayout>
  );
}
